import React from "react";

export const Trash = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M2 4H3.33333H14"
        stroke="#2A2A2A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6666 3.99967V13.333C12.6666 13.6866 12.5261 14.0258 12.2761 14.2758C12.026 14.5259 11.6869 14.6663 11.3333 14.6663H4.66659C4.31296 14.6663 3.97382 14.5259 3.72378 14.2758C3.47373 14.0258 3.33325 13.6866 3.33325 13.333V3.99967M5.33325 3.99967V2.66634C5.33325 2.31272 5.47373 1.97358 5.72378 1.72353C5.97382 1.47348 6.31296 1.33301 6.66659 1.33301H9.33325C9.68687 1.33301 10.026 1.47348 10.2761 1.72353C10.5261 1.97358 10.6666 2.31272 10.6666 2.66634V3.99967"
        stroke="#2A2A2A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66675 7.33301V11.333"
        stroke="#2A2A2A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33325 7.33301V11.333"
        stroke="#2A2A2A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
